module.exports = __webpack_public_path__ + "static/media/thunderstorm.0db1aaf8.svg";